"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_e__sim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "19e206ba-6540-4971-9772-a75ac5943ae0",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192.02 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "e-sim_mid"), /*#__PURE__*/React.createElement("g", {
    id: "ace20583-ab14-4882-8e7e-892009e097a6",
    "data-name": "Pet"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "a22838f6-12d2-4ef9-96c3-4c5ff6a44880",
    "data-name": "ea531758-bf67-4275-a57c-b126455816b6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,36A12.28,12.28,0,0,1,156,48.26v95.48A12.28,12.28,0,0,1,143.75,156H48.28A12.27,12.27,0,0,1,36,143.74V48.26A12.27,12.27,0,0,1,48.28,36h95.47m0-4H48.28A16.26,16.26,0,0,0,32,48.26v95.48A16.26,16.26,0,0,0,48.28,160h95.47A16.27,16.27,0,0,0,160,143.74V48.26A16.27,16.27,0,0,0,143.75,32Z",
    transform: "translate(0 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,56v80H56V89.66L89.67,56H136m4-4H88L52,88v52h88V52Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.08,
    y1: 32,
    x2: 58.08,
    y2: 17.85,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.95,
    y1: 32,
    x2: 81.95,
    y2: 17.85,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.01,
    y1: 32,
    x2: 110.01,
    y2: 17.85,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.99,
    y1: 32,
    x2: 133.99,
    y2: 17.85,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.08,
    y1: 174.15,
    x2: 58.08,
    y2: 160,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.95,
    y1: 174.15,
    x2: 81.95,
    y2: 160,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.01,
    y1: 174.15,
    x2: 110.01,
    y2: 160,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.99,
    y1: 174.15,
    x2: 133.99,
    y2: 160,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.02,
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_e__sim;
exports.default = _default;